// Only extend DT sorting once datables settings object is loaded
function waitForDT() {
    if (typeof jQuery.fn.dataTableExt !== "undefined") {
        jQuery.fn.dataTableExt.aTypes.unshift(
            function ( sData )
            {
                //pass any html formatted nulls as strippedNumerics
                if(sData === "<em>null</em>") {
                    return 'strippedNumerics';
                }

                // try to interpret this as a number
                sData = (sData==="-") ? 0 : sData.toString().replace( /[^\d\-\.]/g, "" );
                number = parseFloat( sData );

                // let datatable auto detect this one
                if(isNaN(number)) {
                    return null;
                }

                // this is some sort of number (with a prefix/suffix) so apply the 'strippedNumerics' data type
                return 'strippedNumerics';
            }
        );

        jQuery.extend( jQuery.fn.dataTableExt.oSort, {
            "auto-pre": function (a) {
                if (a == "[NULL]" || a == "[blank]" || a == "") {
                    return Number.NEGATIVE_INFINITY;
                }
                if (isNaN(+a)) {
                    return jQuery.fn.dataTableExt.oSort["diacritics-neutralise-pre"](a);
                } else {
                    return parseFloat(a);
                }

            },

            "strippedNumerics-pre": function(){
              // Returns matches in the form [value, prefix, value, suffix]
                var valueMatcher = /^([^\d\-]*)(\-?[\d,]+(?:\.\d+)?)(\D*)$/,
                    commaMatcher = /,/g; // replace commas
                return function (value) {
                    if (value === "-") {
                        return 0;
                    // If it's blank or null; return -∞
                    } else if (value == "[NULL]" || value == "[blank]" || value == "" || value == "<em>null</em>") {
                        return Number.NEGATIVE_INFINITY;
                    } else if (value != null && value.match != null) {
                        var match = value.match(valueMatcher);
                        if (match) {
                            var parsedValue = parseFloat(match[2].replace(commaMatcher, ""));
                            if (!isNaN(parsedValue)) {
                                return parsedValue;
                            }
                        }
                    }
                    // Any other type of number will sort correctly, so return the value or date
                    return Date.parse( value ) || value;
                }
            }(),

            "rjmdate-pre": function ( a ) {
                // Use date.js for date parsing, but handle special cases
                // first (i.e. cases that date.js will do incorrectly)
                var match, exp;

                //Make sure a is a string value
                a = a.toString()

                if(match = (exp = /'(\d+)/).exec(a)) // apostrophes
                    a = a.replace(exp, fixupYear(match[1]));
                if(match = (exp = /(Q\d) /).exec(a)) { // Quarters
                    a = a.replace(exp, "") + "" + match[1].replace("Q","");
                    return a; // can be sorted off of raw string
                }
                if(match = (exp = /Hour (\d+)/).exec(a)) // Hours
                    a = a.replace(exp, "") + match[1] + ":00:00";
                if(match = (exp = /(\d+):(\d+\s*)(AM|PM)/).exec(a)) { // Hours with AM/PM
                    var hour = parseInt(match[1]) % 12;
                    a = a.replace(exp, hour + (match[3]=="AM" ? 0 : 12) + ":00:00");
                }

                // modify remaining special cases to simpler forms
                // e.g. change "Week of 1/1/2006" to just "1/1/200"
                a = a.replace(/Week of | \- | to .*/, "");
                return Date.parse( a ) || a;
            }
        });
    } else {
        setTimeout(function() {
            waitForDT();
        }, 100);
    }
}
    // When RequireJS minifies/optimizes the Dashboard JS code,
    // this file was executing before DT finished loading. Here
    // we ensure that DataTables has initialized before we extend
    // its sorting functionality.
    waitForDT();

    // Given a full year, like 2006, will return that year
    // if given a shorter year, like 6 or 56, will return
    // full year in proper century, like 2006 and 1956.
    function fixupYear(year) {
    year = parseInt(year, 10);
    if (year <= ((new Date).getFullYear() % 100))
        year = 2000 + year;
        return new Date(year, 1, 1, 0, 0, 0, 0).getFullYear();
    }
    